import React, { useMemo } from 'react';

import { ReactComponent as OriginDot } from './origin-dot.svg';
import { ReactComponent as DestinationDot } from './destination-dot.svg';
import { ReactComponent as DRIVE } from './drive.svg';
import { ReactComponent as TWO_WHEELER } from './two-wheeler.svg';
import { ReactComponent as OriginMarker } from './origin-marker.svg';
import { ReactComponent as DestinationMarker } from './destination-marker.svg';
import { ReactComponent as Add } from './add.svg';
import { ReactComponent as Remove } from './remove.svg';
import { ReactComponent as Clear } from './clear.svg';
const images = {
  OriginDot,
  DestinationDot,
  DRIVE,
  TWO_WHEELER,
  OriginMarker,
  DestinationMarker,
  Add,
  Remove,
  Clear,
};

const Image = ({ type, color, strokeColor, text, onClick }) => {
  const SVG = useMemo(() => {
    const SVGComponent = images[type];
    return SVGComponent ? (
      <SVGComponent style={{ fill: color || undefined, stroke: strokeColor || undefined }} />
    ) : null;
  }, [type, color, strokeColor]);

  return (
    <div className={`img-${type}`} onClick={onClick}>
      {SVG}
      {text !== undefined && <span>{text}</span>}
    </div>
  );
};

export default React.memo(Image);
